import React from "react";

import { Icon } from "@partials";

import { PageLinkType } from "../types";

export const PageLinks: React.FC<PageLinkType> = ({ pageLinks, title }) => {
  if (!pageLinks) return null;

  const searchIconAlt = "search";
  const searchIconSvg = `<path fill-rule="evenodd" clip-rule="evenodd" d="M3.02865 7.3335C3.02865 4.75617 5.11798 2.66683 7.69531 2.66683C10.2726 2.66683 12.362 4.75617 12.362 7.3335C12.362 9.91083 10.2726 12.0002 7.69531 12.0002C5.11798 12.0002 3.02865 9.91083 3.02865 7.3335ZM7.69531 1.3335C4.3816 1.3335 1.69531 4.01979 1.69531 7.3335C1.69531 10.6472 4.3816 13.3335 7.69531 13.3335C9.18243 13.3335 10.5432 12.7925 11.5915 11.8965L14.3619 14.6669L15.3047 13.7241L12.5036 10.923C13.2521 9.92204 13.6953 8.67953 13.6953 7.3335C13.6953 4.01979 11.009 1.3335 7.69531 1.3335Z"></path>`;

  return (
    <div className="mb-8">
      <p className="mb-6 text-2xl">{title}</p>
      {pageLinks.map((link, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="mb-4 flex items-center" key={index}>
          <Icon
            name="search-icon"
            viewBox="0 0 17 16"
            svg={searchIconSvg}
            alt={searchIconAlt}
            className="mr-2 h-4 w-4 fill-grey-80"
          />
          <a className="group block break-words" href={link.url} target={link.target}>
            <p className="text-base underline">{link.title}</p>
          </a>
        </div>
      ))}
    </div>
  );
};
